var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M19 2.25H5A2.752 2.752 0 0 0 2.25 5v14A2.752 2.752 0 0 0 5 21.75h14A2.752 2.752 0 0 0 21.75 19V5A2.752 2.752 0 0 0 19 2.25zM5 3.75h14c.689 0 1.25.561 1.25 1.25v3.25H3.75V5c0-.689.561-1.25 1.25-1.25zm14 16.5H5c-.689 0-1.25-.561-1.25-1.25V9.75h16.5V19c0 .689-.561 1.25-1.25 1.25zM5.25 6A.75.75 0 0 1 6 5.25h1a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 9.25 6z",
    opacity: 1,
    "data-original": "#112d55",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M13.25 13a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75zM18 15.25h-4a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zm-5.326 1.998a1.253 1.253 0 0 1-1.231 1.502H6.556a1.256 1.256 0 0 1-1.231-1.503 3.737 3.737 0 0 1 1.658-2.392A2.73 2.73 0 0 1 6.25 13c0-1.517 1.233-2.75 2.75-2.75s2.75 1.233 2.75 2.75a2.73 2.73 0 0 1-.733 1.855 3.736 3.736 0 0 1 1.658 2.393zM9 14.25c.689 0 1.25-.561 1.25-1.25S9.689 11.75 9 11.75s-1.25.561-1.25 1.25.561 1.25 1.25 1.25zm2.122 3c-.313-.885-1.161-1.5-2.122-1.5s-1.81.615-2.122 1.5z",
    opacity: 1,
    "data-original": "#549bff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffing);
export default __webpack_public_path__ + "static/media/staffing.01efbb9b888f889ecfa6fed3ebd4b9ac.svg";
export { ForwardRef as ReactComponent };